export default "__VITE_ASSET__Cwdcldsc__"